import React from 'react';
import { Helmet } from 'react-helmet';
import banner from '../assets/Service-Banner.png';
import ServiceGrid from '../components/ServiceGrid';
import ServiceHighlight from '../components/ServiceHighlight'; // <-- Import the new section
import Hero from '../components/Hero';
import { useNavigate } from 'react-router-dom';
import Services from './../components/Services';

const AboutUs = () => {
  const navigate = useNavigate();
  const handleServicesClick = () => {
    navigate('/contact');
  };
  return (
    <>
    <Helmet>
      <link rel="canonical" href="https://driveincarspa.com/service" />
      <title>Professional Car Wash & Detailing Experts
 | Drive-in Car Spa</title>
      <meta name="description" content=" Looking for the best car spa service in Bangalore? We offer popular car spa services, professional car wash company solutions, and top car wash machine service. Find the best car spa services near you with expert cleaning and affordable packages." />
      <meta name="keywords" content="Best Car spa Service in Bangalore
, popular Car Spa Services, best car spa services near me, professional car wash company,  top car wash machine service" />
       <meta name="author" content="DriveIn Team" />
    </Helmet>
      <Hero
      title={
  <>
    <span className="highlight">More Than Just a </span><br />
    Car Wash – Best Car Spa Service in Bangalore
  </>
}
        bgImage={banner}
        onButtonClick={handleServicesClick}
        buttonText="Contact Us"
      />
     <Services/>
      <ServiceHighlight />
      <ServiceGrid />
    </>
  );
};

export default AboutUs;

